import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateSpinWheelEntity } from '../../domain/entities/CreateUpdateSpinWheelEntity'
import type { SpinWheelRegionEntity } from '../../domain/entities/SpinWheelRegionEntity'

export class CreateUpdateSpinWheelModel extends CreateUpdateSpinWheelEntity {
  userIds?: Array<string> | null
  branchIds?: Array<number> | null
  declare spinWheelRegions?: Array<SpinWheelRegionEntity> | null

  constructor(dataDto: CreateUpdateSpinWheelEntity) {
    super()
    mapEntityProperties<CreateUpdateSpinWheelModel>(this, dataDto, {
      exclude: ['prizes', 'users', 'branchs', 'spinWheelRegions'],
      map: {
        userIds: dataDto.users?.map((user) => user.id),
        prizes: dataDto.prizes?.map((prize) => ({
          prizeId: prize.id,
          probability: prize.probability
        })),
        branchIds: dataDto.branchs?.map((branch) => branch.id),
        spinWheelRegions: dataDto.spinWheelRegions?.map((region) => ({
          regionId: region.region?.id,
          districtIds: region.districtIds
        }))
      }
    })
  }
}
